import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostCodes } from '../../actions/postCodesActions';

const usePostCodes = () => {
	const dispatch = useDispatch<any>();
	const { postCodes, postCodesError, postCodesLoading } = useSelector(({ postCodesReducer }) => postCodesReducer);

	useEffect(() => {
		if (postCodes === null && !postCodesError && !postCodesLoading) {
			dispatch(fetchPostCodes());
		}
	}, [postCodes, postCodesError, postCodesLoading, dispatch]);

	return {
		postCodes,
		postCodesError,
		postCodesLoading,
	};
};

export default usePostCodes;
